import CustomButton from "./Button"

const PrimaryButton = ({ isVerified, ...props }) => {
    return (
        <CustomButton
            {...props}
            type="primary"
            style={{
                padding: "24px 32px",
                border: "none",
                backgroundColor: isVerified ? "#00874F" : undefined,
                color: isVerified ? "#fff" : "#fff",
                borderRadius: 5,
            }}
        >
            {props.children}
        </CustomButton>
    )
}

export default PrimaryButton    